import { render, staticRenderFns } from "./DeslindeDialog.vue?vue&type=template&id=052b9502&"
import script from "./DeslindeDialog.vue?vue&type=script&lang=js&"
export * from "./DeslindeDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeslindeDialog.vue?vue&type=style&index=0&id=052b9502&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports